import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Sender, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'k-icon-message'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        'ev-messageSend': this.onMessageSend,
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['prefix'] = function($super) {
                        return (
                            _$cc(Icon, _$tmp0)
                        );
                    }),
                    (__$blocks['prefix'] = function($super, data) {
                        var block = $blocks['prefix'];
                        var callBlock = function() {
                            return _$blocks['prefix'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em),
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value')
    });
};